import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface QuizNavigationProps {
  onPrevious: () => void;
  onNext: () => void;
  canGoPrevious: boolean;
  canGoNext: boolean;
  isLastQuestion: boolean;
  isSubmitting: boolean;
}

export const QuizNavigation: React.FC<QuizNavigationProps> = ({
  onPrevious,
  onNext,
  canGoPrevious,
  canGoNext,
  isLastQuestion,
  isSubmitting
}) => {
  return (
    <div className="bg-white border-t border-gray-200 p-4 shadow-lg">
      <div className="flex justify-between items-center max-w-md mx-auto">
        <button
          onClick={onPrevious}
          disabled={!canGoPrevious}
          className={`px-6 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center ${
            canGoPrevious
              ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              : 'bg-gray-50 text-gray-400 cursor-not-allowed'
          }`}
        >
          <ChevronLeftIcon className="h-5 w-5 mr-2" />
          Precedente
        </button>

        <button
          onClick={onNext}
          disabled={!canGoNext || isSubmitting}
          className={`px-6 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center ${
            canGoNext && !isSubmitting
              ? isLastQuestion 
                ? 'bg-green-600 text-white hover:bg-green-700'
                : 'bg-primary-600 text-white hover:bg-primary-700'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          {isSubmitting ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
              Invio...
            </>
          ) : isLastQuestion ? (
            'Termina Quiz'
          ) : (
            <>
              Successiva
              <ChevronRightIcon className="h-5 w-5 ml-2" />
            </>
          )}
        </button>
      </div>
    </div>
  );
};
